
































import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Action, Mutation, namespace } from "vuex-class";

@Component({
  components: {},
})
export default class CheckList extends Vue {
  @Prop({ default: () => [] }) data: any;

  moment = moment;

  get value() {
    const complated = this.data.filter((item: any) => this.isChecked(item)).length;
    const total = this.data.length;
    return Math.floor((complated / total) * 100) + "%";
  }

  isChecked(item: any) {
    return item.checked ?? item.isDone ?? false;
  }

  itemContent(item: any) {
    return item.content ?? item.contents ?? "";
  }

  createdTime(item: any) {
    const value = item.createdTime || item.createdAt || item.CreatedTime;
    return value ? moment(value).format("MM/DD HH:mm") : "";
  }

  completedTime(item: any) {
    const value = item.updatedTime || item.updatedAt || item.UpdatedTime;
    return value ? moment(value).format("MM/DD HH:mm") : "";
  }

  change(item: any) {
    this.$emit("change", item);
  }
}
